export const getMouseOrientation = (
  isMobile: boolean,
  isPortrait: boolean,
  X: number,
  Y: number,
  altDim: number
) => {
  const invert = isMobile && isPortrait;
  return {
    x: invert ? Y : X,
    y: invert ? altDim - X : Y,
  };
};
